"use client";
import React from "react";
const ExperimentContext = React.createContext({});
export const ExperimentProvider = ExperimentContext.Provider;
const useExperiment = (name) => {
    const context = React.useContext(ExperimentContext);
    return context[name] || (() => false);
};
export default useExperiment;
